import { CommissionTypeEntity } from './../../entities/commissionType.entity';
import { createEffect, ofType, Actions } from "@ngrx/effects";
import {
  withLatestFrom,
  switchMap,
  map,
  catchError
} from "rxjs/operators";
import { Store } from "@ngrx/store";
import { DaveActions } from "../actions/actions";
import { HttpService } from "../../services/http.service";
import { State } from "../index";
import { CommissionTypeActionTypes } from "../actions/commissionType.actions";
import { CommissionTypeEntityFromBackend } from "../../entities/commissionType.entity";
import { BaseActionTypes } from "../actions/base.actions";
import { exhaustMap, of } from 'rxjs';
import { Injectable } from "@angular/core";

enum ErrorCodes {
  Load = "Auftragstypen Abrufen fehlgeschlagen",
  Modify = "Auftragstypen Bearbeiten fehlgeschlagen"
}

@Injectable()
export class CommissionTypeEffects {

  LoadCommissionTypes = createEffect(() => this.actions$.pipe(
    ofType(CommissionTypeActionTypes.GetCommissionTypeRequest),
    withLatestFrom(this.store$),
    exhaustMap(([action, store]) => {
      const queryString = `query{commissiontype{${CommissionTypeEntity.GQLFields}}}`;
      return this.gatewayHttpService
        .graphQl({ query: queryString }, { token: store.base.token, retry: true })
        .pipe(
          map(res =>
            res && res.commissiontype
              ? CommissionTypeActionTypes.UpdateCommissionType({
                  Payload: res.commissiontype.map(val =>
                    CommissionTypeEntityFromBackend(val)
                  )
                })
              : BaseActionTypes.ErrorAction({
                  Payload: { ToasterMessage: ErrorCodes.Load }
                })
          ),
          catchError((err, caught) =>
            of(
              BaseActionTypes.ErrorAction({
                Payload: {
                  ToasterMessage: ErrorCodes.Load,
                  Err: err,
                  Caught: caught
                }
              })
            )
          )
        );
    })
  ));
  constructor(
    private actions$: Actions<DaveActions>,
    private store$: Store<State>,
    private gatewayHttpService: HttpService
  ) {}
}
